import { useCallback } from "react";
import useWorkspaces from "./useWorkspaces";
import buildKnowledgeHubDocUrl from "../Utils/buildKnowledgeHubDocUrl";

/**
 * Returns a `chipHref(option)` function that builds the Knowledge Hub
 * deep-link for a given document chip
 * (`/workspaces/<id>/mrc_contents/<documentId>`).
 *
 * `option` is the react-select value object shaped `{ value, label }` (the
 * document id lives in `.value`); falls back to `.id` for non-select callers.
 *
 * @returns {(option: object) => string|null}
 */
const useKnowledgeHubChipHref = () => {
  const { getActiveWorkspace } = useWorkspaces();
  const workspaceId = getActiveWorkspace?.()?.id;
  return useCallback(
    (item) => buildKnowledgeHubDocUrl(workspaceId, item?.value || item?.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [workspaceId],
  );
};

export default useKnowledgeHubChipHref;
